var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "page-wrapper",
      attrs: { "element-loading-text": "修改中..." }
    },
    [
      _c("swb-login-head", { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c("div", { staticClass: "reg-wrapper serv" }, [
        _c("div", { staticClass: "logreg-banner", attrs: { id: "regist" } }, [
          _c(
            "div",
            { staticClass: "logreg-form login-fixed" },
            [
              _c("h2", { staticClass: "title" }, [_vm._v("账户重置密码")]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "user",
                  staticClass: "demo-ruleForm",
                  attrs: { model: _vm.user, rules: _vm.rules }
                },
                [
                  _c("div", { staticClass: "form-row reg mb20" }, [
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "phoneNo" } },
                          [
                            _c("label", { staticClass: "group-laber" }, [
                              _c("i", { staticClass: "fa fa-user-o font18" })
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "font14",
                              attrs: {
                                type: "text",
                                placeholder: "邮箱/用户名/已验证手机",
                                "auto-complete": "off"
                              },
                              model: {
                                value: _vm.user.phoneNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "phoneNo", $$v)
                                },
                                expression: "user.phoneNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-row reg mb20",
                      class: { "display-none": !_vm.isOutlandMobileNo }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-value" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "smsEmail" } },
                            [
                              _c("label", { staticClass: "group-laber" }, [
                                _c("i", { staticClass: "fa fa-lock font18" })
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "目前 对于海外手机号 需要绑定邮箱用来接收手机短信及验证码",
                                    placement: "right-start"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "font14",
                                    attrs: {
                                      type: "email",
                                      placeholder: "绑定邮箱",
                                      "auto-complete": "off"
                                    },
                                    model: {
                                      value: _vm.user.smsEmail,
                                      callback: function($$v) {
                                        _vm.$set(_vm.user, "smsEmail", $$v)
                                      },
                                      expression: "user.smsEmail"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row reg mb20" }, [
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        !_vm.btnlock
                          ? _c(
                              "label",
                              {
                                class: _vm.btnClass,
                                on: {
                                  click: function($event) {
                                    _vm.sendSmsForPasswordReset()
                                  }
                                }
                              },
                              [_vm._v("获取验证码")]
                            )
                          : _c("label", { class: _vm.btnClass }, [
                              _vm._v("( " + _vm._s(_vm.nums) + " ) 秒后获取")
                            ]),
                        _vm._v(" "),
                        _c("el-form-item", { attrs: { prop: "smsCode" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user.smsCode,
                                expression: "user.smsCode"
                              }
                            ],
                            staticClass: "sms font14",
                            attrs: {
                              type: "text",
                              placeholder: "请输入手机验证码"
                            },
                            domProps: { value: _vm.user.smsCode },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.user,
                                  "smsCode",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row reg mb20" }, [
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("label", { staticClass: "group-laber" }, [
                              _c("i", { staticClass: "fa fa-lock font18" })
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "font14",
                              attrs: {
                                type: "password",
                                placeholder: "设置密码",
                                "auto-complete": "off"
                              },
                              model: {
                                value: _vm.user.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "password", $$v)
                                },
                                expression: "user.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row reg mb20" }, [
                    _c(
                      "div",
                      { staticClass: "form-value" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "rePassword" } },
                          [
                            _c("label", { staticClass: "group-laber" }, [
                              _c("i", { staticClass: "fa fa-lock font18" })
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "font14",
                              attrs: {
                                type: "password",
                                placeholder: "确认密码",
                                "auto-complete": "off"
                              },
                              model: {
                                value: _vm.user.rePassword,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "rePassword", $$v)
                                },
                                expression: "user.rePassword"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "swb-btn mb20",
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.submitForm("user")
                        }
                      }
                    },
                    [_vm._v("重置密码")]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("swb-login-foot")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-hint" }, [
      _c("div", { staticClass: "msg-warn hidden" }, [
        _c("i", { staticClass: "fa fa-lightbulb-o hint-icon" }),
        _vm._v(" 公共场所不建议自动登录，以防账号丢失")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33f56b8e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f56b8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/user/LogPassReset.vue
// module id = 3484
// module chunks = 1